/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import {
  colors,
  Menu,
  MenuItem,
  useMenu,
  useMenuOpenState,
} from '@smartsheet/lodestar-core';
import { KebabIcon } from '@smartsheet/lodestar-icons';
import { useTranslation } from 'react-i18next';
import { IconButton } from '../../../../common/IconButton';

interface ItemData {
  title: string;
  onClick(...args: any): any;
}

interface KebabMenuProps {
  items: ItemData[];
  id: string;
  menuArialabel: string;
}

const KebabMenu = (props: KebabMenuProps) => {
  const { items, id, menuArialabel } = props;

  const { t: translate } = useTranslation();

  const openHelpers = useMenuOpenState();
  const { getTargetHTMLProps, getMenuProps } = useMenu({
    ...openHelpers,
  });

  const kebabButtonStyle = css`
    && {
      height: 18px;
      width: 18px;
      color: ${colors.neutralDark40};
      padding: 0;
      border-radius: 1px;
      && :hover {
        background: ${colors.buttonDefaultPressed};
      }
    }
  `;

  return (
    <div>
      <IconButton
        {...getTargetHTMLProps()}
        appearance="borderless"
        css={kebabButtonStyle}
        aria-label={translate('common:options')}
      >
        <KebabIcon size="xSmall" />
      </IconButton>
      <Menu
        {...getMenuProps({
          'aria-label': menuArialabel,
        })}
        id={id}
        placement={'bottom-start'}
      >
        {items.map((item, key) => (
          <MenuItem key={key} onClick={item.onClick}>
            {item.title}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

KebabMenu.displayName = 'KebabMenu';

export default KebabMenu;
